import { IFoodAmount, TUnit } from "../../shared/Recipes";
import FoodList from "./FoodList";
import { useEffect, useRef, useState } from "react";
import { UnitOptions } from "../../data/RecipeCache";
import { Evaluators } from "../../gui/TextInput/TextInput";
import Dropdown from "../../gui/Dropdown/Dropdown";
import IconButton from "../../gui/Button/IconButton";
import { UpdateEvent } from "../../gui/GUIEvents";
import FormControl from "../../gui/Form/FormControl";
import Validators from "../../gui/Form/Validators";
import TextInput from "../../gui/TextInput/TextInput";
import DeleteIcon from "../../gui/Icons/DeleteIcon";

export interface IFoodRowProps {
    index:number
    foodAmount:IFoodAmount
    foodIds:number[]
    onDelete:(index:number) => void
    onUpdate:(index:number,food:IFoodAmount) => void
}
export default function FoodRow(props:IFoodRowProps){
    const [foodId,setFoodId] = useState<number>(props.foodAmount.id)
    const [amount,setAmount] = useState<string>(props.foodAmount.amount ? props.foodAmount.amount.toString() : "")
    const [unit,setUnit] = useState<TUnit>(props.foodAmount.unit)
    const mounted = useRef<boolean>(false)

    useEffect(() => {
        if (mounted.current) props.onUpdate(props.index, {id:foodId,amount:parseInt(amount),unit})
        else mounted.current = true
    }, [foodId,amount,unit])

    const onFood = (e:UpdateEvent<number>) => { setFoodId(e.value||0) }
    const onAmount = (e:UpdateEvent<string>) => { setAmount(e.value||"") }
    const onUnit = (e:UpdateEvent<string>) => { e.value && setUnit(e.value as TUnit) }
    const onDelete = (e:any) => props.onDelete?.(props.index)

    return <div className="row">
        <FormControl validators={[Validators.Required("Food")]}>
            <FoodList foodId={props.foodAmount.id} onUpdate={onFood} index={props.index} foodIds={props.foodIds}/>
        </FormControl>
        <FormControl validators={[Validators.PositiveNumber("Amount", "Required", "Required")]}>
            <TextInput placeholder="Amount" value={amount.toString()} onUpdate={onAmount} evaluator={Evaluators.Number}/>
        </FormControl>
        <Dropdown className="unit" options={UnitOptions} value={unit} defaultValue={props.foodAmount.unit || "g"} onUpdate={onUnit} hideArrow={true} anchorProps={{width:"match"}}/>
        <IconButton onClick={onDelete}><DeleteIcon/></IconButton>
    </div>
}